<template>
  <div class="empty-bag">
    <p class="text">Your bag is empty</p>
    <div class="button-group">
      <Button
        v-for="item in menu"
        :key="item.url"
        :href="item.url"
        full-width
        theme="outline"
        tag="a"
      >
        {{ item.title }}
      </Button>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import menuQuery from "@/graphql/queries/Menu.gql";

export default {
  name: "EmptyBagState",
  components: {
    Button,
  },
  data() {
    return {
      menu: [],
    };
  },
  apollo: {
    menu: {
      query: menuQuery,
      variables() {
        return {
          handle: "empty-bag-menu",
        };
      },
      update({ menu }) {
        return menu.items;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-bag .text {
  text-align: center;
  @include t__utility-body-20;
  padding: 15px 0;
  margin-bottom: 15px;
}

.button-group {
  padding: 0 40px;

  & > * {
    margin: 0 0 15px;
  }
}
</style>
